// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"登录","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/doc","layout":false,"id":"3"},"4":{"path":"/doc/auth","layout":false,"id":"4"},"5":{"name":"产品","icon":"table","path":"/product","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/order","name":"订单管理","icon":"FolderOutlined","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/order","redirect":"/order/list","parentId":"6","id":"7"},"8":{"path":"/order/list","name":"订单列表","parentId":"6","id":"8"},"9":{"path":"/order/consume/list","name":"消费记录","parentId":"6","id":"9"},"10":{"path":"/","redirect":"/product","parentId":"ant-design-pro-layout","id":"10"},"11":{"path":"*","layout":false,"id":"11"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__User__Login__index" */'@/pages/User/Login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__Api__index" */'@/pages/Api/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Auth__index" */'@/pages/Auth/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__Product__index" */'@/pages/Product/index.tsx')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__Order__index" */'@/pages/Order/index.tsx')),
'9': React.lazy(() => import(/* webpackChunkName: "p__Consume__index" */'@/pages/Consume/index.tsx')),
'10': React.lazy(() => import('./EmptyRoute')),
'11': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/Users/zhangmin/Documents/project/jsq/paas_backend/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
